import { render, staticRenderFns } from "./DisabledSecondaryFlat.vue?vue&type=template&id=b6beea36"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports